import { useState } from 'react';
import { Page } from 'consts/PaymentConst';

// 共通決済画面のページ遷移を管理するhook
export const usePaymentPage = () => {
	const [page, setPage] = useState(Page.DEFAULT);
	const isDefault = () => {
		return Page.DEFAULT === page;
	};
	const isShowSavedCard = () => {
		return Page.SHOW_SAVED_CARD === page;
	};
	const isDeleteCard = () => {
		return Page.DELETE_CARD === page;
	};
	const isUnSupported = () => {
		return Page.UN_SUPPORTED === page;
	};
	const isServiceError = () => {
		return Page.SERVICE_ERROR === page;
	};

	return {
		page,
		setPage,
		isDefault,
		isShowSavedCard,
		isDeleteCard,
		isUnSupported,
		isServiceError,
	};
};
